export default __webpack_public_path__ + "static/media/download (6).8770283e.svg";